import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { PROJECT_MEMBER_PREFIX_URL } from './constants/config.project-member'

const ListPage = lazy(() => import('./pages/ListPage.ProjectMember'))

const ProjectMemberRouters: AppRouterItem[] = [
  {
    path: `${PROJECT_MEMBER_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default ProjectMemberRouters
